import React, { useEffect, useState } from "react";
import { absoluteURL } from "../../Utils";
import i18n from "../../modules/Auth/pages/i18n";
import { useTranslation } from "react-i18next";

function HouseKeepingRoomsUpdated({
  roomNumber,
  roomStatus,
  roomStatusText,
  roomCleanStatus,
  handleStatusChange,
  checked,
  selectedLanguage,
}) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);
  // setting the ribbon color
  const [ribbonColor, setRibbonColor] = useState("red");

  useEffect(() => {
    if (roomCleanStatus === "DIRTY") {
      setRibbonColor("red");
    }
    if (roomCleanStatus === "dirtyBackup") {
      setRibbonColor("orange");
    }
    if (roomCleanStatus === "CLEAN") {
      setRibbonColor("#40B394");
    }
    if (roomCleanStatus === "OCCUPIED") {
      setRibbonColor("blue");
    }
    if (roomCleanStatus === "BLOCKED") {
      setRibbonColor("#D3D3D3");
    }
  }, [roomCleanStatus]);

  return (
    <div className="houseKeepingRoomUpdatedWrapper">
      <div className="ribbonWrapper" style={{ backgroundColor: ribbonColor }} />
      <div className="roomInfoWrapper">
        <div className="roomNoWrapper">{roomNumber}</div>
        <div className="roomOccupiedStatus">
          {roomStatus === "Vacant" && (
            <img
              src={absoluteURL("./media/housekeeping/user.png")}
              alt=""
              className="roomUserImg"
            />
          )}
          {roomStatus === "Occupied" && (
            <img
              src={absoluteURL("./media/housekeeping/userFilled.png")}
              alt=""
              className="roomUserImg"
            />
          )}
        </div>
      </div>
      <div className="cleanRoomStatus">
        <input
          className="cleanStatusChecked"
          type="checkbox"
          id={roomNumber}
          value={roomCleanStatus}
          onClick={(event) => handleStatusChange(event)}
        />
        <div className="cleanStatus">
          {roomCleanStatus === "DIRTY" && `${t("Mark it Clean")}`}
          {roomCleanStatus === "CLEAN" && `${t("Mark it Dirty")}`}
          {roomCleanStatus === "OCCUPIED" && `${t("Mark it Dirty")}`}
        </div>
      </div>
    </div>
  );
}

export default HouseKeepingRoomsUpdated;
